// 考试管理
import request from '@/router/axios';

let urlPrefix = '/api/exam/etexam';

/**
 * 新增考试
 * @param {Object} data 考试信息
 * @param {String} data.antiCheating 防作弊，多个用','隔开 1题目乱序，2选项乱序，3切屏次数自动交卷,切屏次数用':'隔开
 * @param {String} data.examName 试卷名称
 * @param {Number} data.examPaperId 试卷id
 * @param {Number} data.examType 考试类型
 * @param {String} data.examSubscribe 描述
 * @param {Array} data.deptIds 参考部门
 * @param {Number} data.deptIds[] 部门deptId
 * @param {String} data.startTime 开始时间
 * @param {String} data.endTime 结束时间
 */
export const addEtexam = data => {
    return request(urlPrefix, { data }, 'post');
};

/**
 * 开始考试
 * @param {Number} examId 考试id
 */
export const startEtexam = examId => {
    return request(`${urlPrefix}/start/${examId}`);
};

/**
 * 试题初始化
 * @param {Number} examId 考试记录ID
 */
export const initques = examId => {
    return request(`${urlPrefix}/student/initques`, { params: { examId } });
};

/**
 * 每次答题进行提交
 * @param {Object} data 题目相关信息
 * @param {String} data.answer 题目答案
 * @param {Number} data.questionId 题目id
 * @param {Number} data.examHistoryId 考试记录id
 */
export const updExamineeListDetail = data => {
    return request(`${urlPrefix}/student/updExamineeListDetail`, { data }, 'put');
};

/**
 * 交卷
 * @param {Number} examId 考试记录ID
 */
export const commitExam = examId => {
    return request(`${urlPrefix}/student/commitExam`, { params: { examId } }, 'put');
};

/**
 * 手工阅卷
 * @param {Object} data 阅卷信息
 * @param {Array} data.answerSheetItems 考试题目阅卷结构列表
 * @param {String} data.answerSheetItems[].answer 用户答案
 * @param {String} data.answerSheetItems[].comment
 * @param {Number} data.answerSheetItems[].point 用户得分
 * @param {Number} data.answerSheetItems[].questionId 题目id
 * @param {Number} data.answerSheetItems[].questionTypeId 题目类型id
 * @param {Boolean} data.answerSheetItems[].right 是否正确作答
 * @param {Number} data.duration
 * @param {Number} data.examHistroyId 学生考试记录id
 * @param {Number} data.examId 考试id
 * @param {Number} data.examPaperId 试卷id
 * @param {Number} data.pointMax
 * @param {Number} data.pointRaw
 * @param {Number} data.startTime
 */
export const answersheet = data => {
    return request(`${urlPrefix}/answersheet`, { data }, 'put');
};

/**
 * 通过id获取考试详情
 * @param {Number} id 考试id
 */
export const getEtexamDetail = id => {
    return request(`${urlPrefix}/${id}`);
};

/**
 * 获取学生考试记录
 * @param {Integer} historyId 考试记录ID
 */
export const getUserExamInfo = historyId => {
    return request(`${urlPrefix}/student/queryUserExamInfo`, { params: { historyId } });
};

/**
 * 分页查询考试列表
 * @param {Number} page 当前页码
 * @param {Number} limit 每页条目数
 * @param {Object} params 其他参数
 */
export const getEtexamList = (page = 1, limit = 10, params = {}) => {
    return request(`${urlPrefix}/query`, {
        params: {
            ...params,
            page,
            limit
        }
    });
};

/**
 * 批量删除
 * @param {Array} data 
 */
export const removeExam = data => {
    return request(`${urlPrefix}/deleteBatch`, { data }, 'delete');
};